export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  CRO = 'ROLE_CRO',
  CRC = 'ROLE_CRC',
  USER = 'ROLE_USER',
}
